








import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import { ApiContent } from '@/models/api/content'
import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SwitchByUa,
  },
})
export default class OnlyFreeAreaLayout extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ default: ApiContent.empty })
  readonly headerFreeArea: ApiContent
}
